<template>
  <CRow class="justify-content-center">
  <CCol>
    <CCard>
      <CForm @submit.prevent="save">
      <CCardHeader class="pb-4">
        <strong>Thông tin sản phẩm</strong>
        <div class="card-header-actions">
          <CButton type="submit" color="info" shape="pill" class="mr-2">
            <CIcon name="cil-save"/>
            Lưu
          </CButton>

          <CButton v-if="productID" type="button" color="secondary" shape="pill" class="mr-2"
                   @click="refreshPage"
          >
            <CIcon name="cil-sync"/>
            Tải lại
          </CButton>

          <CButton v-if="getAllowDeleteButton" type="button" color="danger" shape="pill" class="mr-2"
                   @click="doDelete"
          >
            <CIcon name="cil-trash"/>
            Xóa
          </CButton>

          <CButton type="button" color="secondary" shape="pill" class="mr-2"
                   @click="goBack"
          >
            <CIcon name="cil-chevron-left"/>
            Quay lại
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
          <CInput
            label="Loại sản phẩm*:"
            type="text"
            v-model="product.group"
            placeholder="Loại sản phẩm"
            required
            horizontal
            :addLabelClasses="'text-right'"
          />
          <CInput
            label="Tên sản phẩm*:"
            type="text"
            v-model="product.product"
            placeholder="Sản phẩm"
            required
            horizontal
            :addLabelClasses="'text-right'"
          />
          <CInput
            label="Mô tả sản phẩm:"
            type="text"
            v-model="product.description"
            placeholder="Mô tả sản phẩm"
            horizontal
            :addLabelClasses="'text-right'"
          />
          <CInput
            label="Số lượng sản xuất tối thiểu:"
            type="number"
            min="1"
            v-model.number="product.min_order"
            placeholder="Thời gian sản xuất (ngày)"
            horizontal
            :addLabelClasses="'text-right'"
          />
          <CInput
            label="Thời gian sản xuất (ngày):"
            type="number"
            v-model="product.lead_time"
            min="1"
            placeholder="Thời gian sản xuất (ngày)"
            horizontal
            :addLabelClasses="'text-right'"
          />
          <CInput
            label="Số lượng sẵn sàng:"
            type="number"
            v-model.number="product.available"
            min="0"
            placeholder="Thời gian sản xuất (ngày)"
            horizontal
            :addLabelClasses="'text-right'"
          />
          <CTextarea
            label="Chỉ tiêu kỹ thuật tóm tắt:"
            placeholder="Chỉ tiêu kỹ thuật tóm tắt"
            type="text"
            v-model="product.specs_note"
            horizontal
            rows="10"
            :addLabelClasses="'text-right'"
          />
          <CInput
            label="Ghi chú:"
            type="text"
            v-model="product.note"
            placeholder="Ghi chú sản phẩm"
            horizontal
            :addLabelClasses="'text-right'"
          />
          </CCol>
          <CCol class="d-flex justify-content-center align-items-center">
            <table style="width: 100%;">
              <tr>
                <td colspan="5" class="text-center">
                  <img
                    v-if="product.image"
                    alt="hình ảnh"
                    :src="product.image" style="width: 400px;">
                  <span class="text-center" v-else>Chưa có ảnh</span>
                </td>
              </tr>
              <tr>
                <td class="text-right">
                      <span>
                        Ảnh 1:
                      </span>
                </td>
                <td colspan="2">
                  <label
                    style="border: 1px solid #ced4da;border-radius: 0.375rem; padding: 0.375rem 0.75rem;"
                    class="m-1"
                    for="fileInputImage2"
                  >{{ fileNameImage }}
                  </label>
                  <input type="file"
                         id="fileInputImage2"
                         accept=".jpg,.jpeg,.png,.gif,.svg"
                         style="display: none;"
                         @change="onFileImageChange">
                </td>
                <td>
                  <CButton v-if="selectedFileImage" shape="pill" color="info"
                           class="mr-2"
                           @click="handleUploadImage(1)"
                           :disabled="isUploadingImage"
                  >
                    <CIcon name="cil-cloud-upload"/>
                    {{ isUploadingImage ? "Đang tải..." : "Tải lên" }}
                  </CButton>
                </td>
              </tr>
              <tr>
                <td colspan="5" class="text-center">
                  <img
                    v-if="product.image2"
                    alt="hình ảnh"
                    :src="product.image2" style="width: 400px;">
                  <span class="text-center" v-else>Chưa có ảnh</span>
                </td>
              </tr>
              <tr>
                <td class="text-right">
                      <span>
                        Ảnh 2:
                      </span>
                </td>
                <td colspan="2">
                  <label
                    style="border: 1px solid #ced4da;border-radius: 0.375rem; padding: 0.375rem 0.75rem;"
                    class="m-1"
                    for="fileInputImage"
                  >{{ fileNameImage2 }}
                  </label>
                  <input type="file"
                         id="fileInputImage"
                         accept=".jpg,.jpeg,.png,.gif,.svg"
                         style="display: none;"
                         @change="onFileImageChange2">
                </td>
                <td>
                  <CButton v-if="selectedFileImage2" shape="pill" color="info"
                           class="mr-2"
                           @click="handleUploadImage(2)"
                           :disabled="isUploadingImage2"
                  >
                    <CIcon name="cil-cloud-upload"/>
                    {{ isUploadingImage2 ? "Đang tải..." : "Tải lên" }}
                  </CButton>
                </td>
              </tr>
            </table>
          </CCol>
        </CRow>

          <CRow>
            <CCol md="3" class="text-right mt-1 p-0">
              Đính kèm chỉ tiêu kỹ thuật:
            </CCol>
            <CCol>
              <CSpinner
                v-if="isUploading"
                color="info"
                class="mr-5 mt-0"
                style="width:1.2rem;height:1.2rem;"
              />

              <CIcon name="cil-paperclip" size="lg" class="mr-2"/>
              <label
                style="border: 1px solid #ced4da;border-radius: 0.375rem;padding: 0.375rem 0.75rem;"
                class="mr-1"
                for="fileInput"
              >{{ fileName }}
              </label>
              <input type="file"
                     id="fileInput"
                     style="display: none;"
                     @change="onFileChange">

              <CButton v-if="selectedFile" shape="pill" color="info"
                       class="mr-2"
                       @click="handleUpload"
                       :disabled="isUploading"
              >
                <CIcon name="cil-cloud-upload"/>
                {{ isUploading ? "Đang tải..." : "Tải lên" }}
              </CButton>

              <CButton v-if="gotInfo && product.attached" shape="pill" color="info"
                       class="mr-2"
                       @click="downloadFile(product.attached)"
              ><CIcon name="cil-cloud-download" class="mr-1"/>Tải xuống</CButton>

              <CButton v-if="gotInfo && product.attached" shape="pill" color="info"
                       @click="previewFile(product.attached)"
              ><CIcon name="cil-screen-desktop" class="mr-1"/>Xem/Ẩn</CButton>

              <span v-if="product.datasheet"> Datasheet: <a :href="product.datasheet" target="_blank" rel="noopener noreferrer">
                {{ convertToPdfFilename(product.attached) }}</a>
              </span>

            </CCol>
          </CRow>

          <div v-if="pdfUrl" class="resizable-container mb-2">
            <iframe :src="pdfUrl" width="100%" height="100%"></iframe>
          </div>
      </CCardBody>
      </CForm>
    </CCard>

    <CCard>
      <CCardHeader>
        <strong>Thông tin tệp sản xuất</strong>
      </CCardHeader>

      <CCardBody>
        <CRow>
          <CCol>
            <CCard>
              <CCardHeader>
                <strong>Tệp chờ phê duyệt</strong>
              </CCardHeader>

              <CCardBody>
                <table>
                  <tr>
                    <td class="text-right">Tên Tệp:</td>
                    <td style="font-weight: bold;">{{product.app_temp}}</td>
                  </tr>
                  <tr>
                    <td class="text-right">MD5: </td>
                    <td style="font-weight: bold;">{{product.app_temp_md5}}</td>
                  </tr>
                  <tr>
                    <td class="text-right">CRC32: </td>
                    <td style="font-weight: bold;">{{product.app_temp_crc32}}</td>
                  </tr>
                </table>
              </CCardBody>

            </CCard>
          </CCol>
          <CCol>
            <CCard>
              <CCardHeader>
                <strong>Tệp đã được phê duyệt</strong>
              </CCardHeader>
              <CCardBody>
                <table>
                  <tr>
                    <td class="text-right">Tên Tệp:</td>
                    <td style="font-weight: bold;">
                      <a
                      :href="product.app_main_link"
                      download
                      class="text-primary"
                      style="cursor: pointer;">
                      {{ product.app_main }}
                    </a>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-right">MD5: </td>
                    <td style="font-weight: bold;">{{product.app_main_md5}}</td>
                  </tr>
                  <tr>
                    <td class="text-right">CRC32: </td>
                    <td style="font-weight: bold;">{{product.app_main_crc32}}</td>
                  </tr>
                </table>
              </CCardBody>

            </CCard>
          </CCol>
        </CRow>
        <CRow class="d-flex justify-content-center">
          <CButton color="primary" class="mx-2" style="width: 200px"
                   @click="">
            PHÊ DUYỆT
          </CButton>
          <CButton color="danger" class="mx-2" style="width: 200px"
                   @click="">
            TỪ CHỐI
          </CButton>
        </CRow>

        <CRow class="pt-5">
          <CCol sm="6" md="8" lg="9">
            <label
              class="form-control"
              for="fileInputImport"
            >{{ fileNameImport }}
            </label>
            <input type="file"
                   accept=".bin"
                   id="fileInputImport"
                   style="display: none;"
                   @change="onFileChangeImport">
          </CCol>
          <CCol sm="6" md="4" lg="3">
            <CButton shape="pill" color="info"
                     style="width: 100%;" @click="handleSubmitImport"
                     :disabled="isUploadingImport"
            >
              <CIcon name="cil-cloud-upload"/>
              {{ isUploadingImport ? "Đang tải..." : "Tải lên" }}
            </CButton>
          </CCol>
        </CRow>
        <CRow v-if="isUploadingImport" class="justify-content-center" style="margin-top: 20px">
          <CSpinner
            color="info"
            style="width:2rem;height:2rem;"
          />
        </CRow>
      </CCardBody>
    </CCard>
  </CCol>
  </CRow>
</template>

<script>

export default {
  data() {
    return {
      allowDelete: false,
      productID: '',
      product: {
        id: 0,
        product: '',
        description: '',
        specs_note: '',
        note: '',
        attached: '',
        image: '',
        lead_time: '',
        image2: '',
        datasheet: '',
        group: '',
        min_order: 0,
        available: 0,
      },
      fileName: 'Chọn tệp chỉ tiêu kỹ thuật', // for purge BOM file upload
      selectedFile: null,
      isUploading: false,
      progress: null,
      gotInfo: false,
      preview: true,
      pdfUrl: null,
      fileNameImport: 'Duyệt tệp',
      selectedFileImport: null, // Holds the selected file object
      isUploadingImport: false,
      fileNameImage: 'Chọn ảnh',
      selectedFileImage: null,
      isUploadingImage: false,
      fileNameImage2: 'Chọn ảnh',
      selectedFileImage2: null,
      isUploadingImage2: false,
    };
  },
  created() {
    // console.log(this.$route)
    this.productID = this.$route.query.id
    if(this.productID) {
      this.refreshPage()
    }
  },
  computed: {
    getAllowDeleteButton() {
      return (this.allowDelete && this.productID)
    }
  },
  methods: {
    refreshPage() {
      // console.log('productID', this.productID)
      this.$request.get(`/api/device/producttypes/${this.productID}`).
      then(res=>{
        console.log(res.data)
        this.product=res.data.product
        if(res.data.status === 'success'){
          if (this.product.attached) {
            this.fileName = this.product.attached
            this.gotInfo = true
          }
        }
      })
    },

    save() {
      // console.log('Lưu product: ', this.product)
      this.$swal.fire({
        title: "Lưu thông tin sản phẩm?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.product.lead_time=String(this.product.lead_time)
          this.$request.post(`/api/device/producttypes`, this.product).
          then(res => {
            if(res.data.status === 'success') {
              this.product = res.data.product;
              this.$swal.fire({
                icon: "success",
                title: this.productID ? "Cập nhật thông tin sản phẩm" : "Tạo thông tin sản phẩm mới",
                html: "Lưu thông tin sản phẩm thành công"
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: this.productID ? "Cập nhật thông tin sản phẩm" : "Tạo thông tin sản phẩm mới",
                html: "Tạo thông tin sản phẩm " + this.product.product +
                  "<br>thất bại: " + res.data.status,
              });
            }
          })
        }
      });
    },
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        this.fileName = this.selectedFile.name;
        // console.log('selected file name:', this.fileName)
      } else {
        // console.log('no file selected');
        this.fileName = 'Chọn tệp chỉ tiêu kỹ thuật'
      }
    },
    handleUpload() {
      if (!this.selectedFile) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      // Create FormData instance to hold the file
      this.isUploading = true;
      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("id", this.product.id)
      // Send file using Axios
      this.$request.post(`/api/device/specsupload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
          if (res.data.status === 'success') {
            this.refreshPage()
            // console.log(res.data.status)
            this.$swal.fire({
              icon: "success",
              title: "Tải lên tệp",
              text: "Tệp: " + this.fileName + " đã tải lên thành công!",
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Tải lên tệp",
              html: "Tệp: " + this.fileName + " lưu lỗi: "+ res.data.status,
            });
          }
          this.isUploading = false;
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Lưu tệp đính kèm",
            html: "Tệp: " + this.fileName + " lưu lỗi: " + error,
          });
          this.isUploading = false;
        });
    },
    downloadFile(fileName) {
      // console.log('downloadFile', fileName)
      this.$request.get(`/api/device/specsdownload/${fileName}?id=${this.product.id}`,
        { responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
          // document.body.removeChild(link); // Clean up
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
        });
    },
    previewFile(fileName) {
      // console.log('previewFile', fileName, 'id:', this.product.id);
      if (this.pdfUrl) {
        this.pdfUrl = null
        return
      }
      this.$request.get(`/api/device/specsdownload/${fileName}?id=${this.product.id}&&preview=yes`, {
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        this.pdfUrl = URL.createObjectURL(blob);
      }).catch((error) => {
        console.error("Error converting DOCX to PDF:", error);
      });
    },
    doDelete() {
      // console.log("Delete product name:", this.product.product);
    },
    goBack() {
      this.$router.go(-1)
    },
    onFileImageChange(event) {
      this.selectedFileImage = event.target.files[0];
      if (this.selectedFileImage) {
        this.fileNameImage = this.selectedFileImage.name;
        console.log('selected file name:', this.fileNameImage)
      } else {
        console.log('no file selected');
        this.fileNameImage = 'Chọn ảnh'
      }
    },
    onFileImageChange2(event) {
      this.selectedFileImage2 = event.target.files[0];
      if (this.selectedFileImage2) {
        this.fileNameImage2 = this.selectedFileImage2.name;
        console.log('selected file name:', this.fileNameImage)
      } else {
        console.log('no file selected');
        this.fileNameImage2 = 'Chọn ảnh'
      }
    },
    handleUploadImage(index) {
      if(index===1) {
        if (!this.selectedFileImage) {
          this.$swal.fire({
            icon: "error",
            title: "Tải lên",
            text: "Vui lòng chọn tệp trước"
          });
          return;
        }
        this.isUploadingImage = true;
        this.handleUploadData(this.fileNameImage, this.selectedFileImage, 'image', index);
        this.isUploadingImage = false;
      } else {
        if (!this.selectedFileImage2) {
          this.$swal.fire({
            icon: "error",
            title: "Tải lên",
            text: "Vui lòng chọn tệp trước"
          });
          return;
        }
        this.isUploadingImage2 = true;
        this.handleUploadData(this.fileNameImage2, this.selectedFileImage2, 'image', index);
        this.isUploadingImage2 = false;
      }
    },
    handleUploadData(fileName, fileData, dataType, index) {
      // console.log("upload: ", fileName, dataType);
      const formData = new FormData();
      formData.append("file", fileData);
      formData.append("id", this.product.id);
      formData.append("data-type", dataType);
      formData.append("index", index);

      // Send file using Axios
      this.$request.post("/api/device/imageupload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        if (res.data.status === 'success') {
          this.refreshPage()
          this.$swal.fire({
            icon: "success",
            title: "Tải lên tệp",
            text: "Tệp: " + fileName + " đã tải lên thành công!",
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Tải lên tệp",
            html: "Tệp: " + fileName + " tải lên lỗi: " + res.data.status,
          });
        }
      }).catch((error) => {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên tệp",
          html: "Tệp: " + fileName + " tải lên lỗi: " + error,
        });
      })
    },
    convertToPdfFilename(filename) {
      return filename.replace(/\.[^/.]+$/, '.pdf');
    },
    handleSubmitImport() {
      if (!this.selectedFileImport) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      this.$swal.fire({
        title: "Nhập thông tin email",
        input: "text",
        inputPlaceholder: "Nhập thông tin email...",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          // Create FormData instance to hold the file
          this.isUploadingImport = true;
          const formData = new FormData();
          formData.append("file", this.selectedFileImport);
          formData.append("id", this.product.id);
          formData.append("message", result.value);
          // Send file using Axios
          this.$request.post("/api/device/binaries", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }).then((res) => {
            if (res.data.status === 'success') {
              // console.log(res.data.status)
              this.$swal.fire({
                icon: "success",
                title: "Tải lên tệp",
                text: "Tệp: " + this.fileNameImport + " đã tải lên thành công!",
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Tải lên tệp",
                html: "Tệp: " + this.fileNameImport + " tải lên lỗi: " + res.data.status,
              });
            }
            this.isUploadingImport = false;
            this.refreshPage()
          }).catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Tải lên tệp",
              html: "Tệp: " + this.fileNameImport + " tải lên lỗi: " + error,
            });
            this.isUploadingImport = false;
          });

        }
      });
    },
    onFileChangeImport(event) {
      this.selectedFileImport = event.target.files[0];
      if (this.selectedFileImport) {
        this.fileNameImport = this.selectedFileImport.name;
        // console.log('selected file name:', this.fileNameImport)
      } else {
        // console.log('no file selected');
        this.fileNameImport = 'Duyệt tệp'
      }
    },
  },
};
</script>

<style>
.resizable-container {
  width: 100%;
  height: 700px;
  resize: vertical; /* Allows vertical resizing */
  overflow: auto; /* Ensures scrollbars appear when needed */
  border: 1px solid #ccc; /* Optional: for better visibility */
  padding: 5px;
}
</style>
